import { reloadOnce } from '@/lib/vitePreloadError';

const bootFailureKey = 'inertia-boot-reload';

// createInertiaApp() throws "null is not an object (evaluating 'initialPage.component')"
// when the #app element it booted against has no data-page attribute - i.e. the document
// wasn't a genuine Inertia response (a stale cached page, an interstitial, etc). Since it's
// an async function called without await/.catch in app.tsx, that throw would otherwise
// surface only as an unhandled promise rejection and leave the user on a blank page.
export function isMissingInitialPageError(error: unknown): boolean {
    return error instanceof TypeError && /initialPage/.test(error.message);
}

export function recoverFromInertiaBootFailure(
    error: unknown,
    storage: Storage | null,
    reload: () => void,
): boolean {
    if (!isMissingInitialPageError(error)) {
        return false;
    }

    const message = error instanceof Error ? error.message : String(error);

    return reloadOnce(`${bootFailureKey}:${message}`, storage, reload);
}
